import { randomizeArray, SpringParallax, Image } from '@ccg/core';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1, { useState, useEffect, useRef } from 'react';
import PropTypes$1 from 'prop-types';
import CssIcon from '../../basics/Icon/Icon.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledTeamList, { StyledMemberItem } from './TeamList.style.js';

const MemberItem = ({
  image,
  name,
  title,
  link,
  status
}) => {
  if (image) {
    const {
      url,
      srcset,
      alt
    } = image;
    const currentImage = useRef(null);

    const handleMouseEnter = e => {
      const position = e.currentTarget.getBoundingClientRect();
      currentImage.current.setAttribute('style', `right: ${e.clientY - position.top}px; left: ${e.clientX - position.left}px`);
      currentImage.current.classList.remove('faded-out');
      currentImage.current.classList.add('faded-in');
    };

    const handleMouseLeave = () => {
      currentImage.current.classList.remove('faded-in');
      currentImage.current.classList.add('faded-out');
    };

    return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(StyledMemberItem, _extends({
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }, link), /*#__PURE__*/React$1.createElement("div", {
      ref: currentImage,
      className: "memberItem__image-wrapper faded-out"
    }, /*#__PURE__*/React$1.createElement(Image, {
      src: url,
      srcset: srcset,
      ratio: "2:3",
      alt: alt,
      lazy: true,
      className: "memberItem__image"
    })), /*#__PURE__*/React$1.createElement("div", {
      className: "memberItem__content"
    }, /*#__PURE__*/React$1.createElement("div", {
      className: "memberItem__name"
    }, /*#__PURE__*/React$1.createElement(Typography$1, {
      transform: "uppercase"
    }, name + (status === 'suspended' ? ' (Alumni)' : ''), /*#__PURE__*/React$1.createElement(CssIcon, null))), /*#__PURE__*/React$1.createElement(Typography$1, {
      className: "memberItem__title"
    }, title))));
  }

  return /*#__PURE__*/React$1.createElement(StyledMemberItem, link, /*#__PURE__*/React$1.createElement("div", {
    className: "memberItem__content"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "memberItem__name"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    transform: "uppercase"
  }, name + (status === 'suspended' ? ' (Alumni)' : ''), /*#__PURE__*/React$1.createElement(CssIcon, null))), /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "memberItem__title"
  }, title)));
};
MemberItem.propTypes = {
  image: PropTypes$1.arrayOf(PropTypes$1.shape({
    url: PropTypes$1.string.isRequired,
    srcset: PropTypes$1.string.isRequired,
    width: PropTypes$1.string.isRequired,
    height: PropTypes$1.string.isRequired,
    hasFocalPoint: PropTypes$1.bool,
    focalPoint: PropTypes$1.arrayOf(PropTypes$1.number),
    credits: PropTypes$1.string,
    alt: PropTypes$1.string
  })),
  name: PropTypes$1.string.isRequired,
  title: PropTypes$1.string,
  link: PropTypes$1.shape(),
  status: PropTypes$1.string
};
MemberItem.defaultProps = {
  image: null,
  title: null,
  link: null,
  status: 'active'
};

const TeamList = ({
  members
}) => {
  const [randomizedMembers, setRandomizedMembers] = useState(null);
  useEffect(() => {
    const shuffledMembers = randomizeArray([...members]);
    setRandomizedMembers(shuffledMembers);
  }, [members]);
  return /*#__PURE__*/React$1.createElement(SpringParallax, null, /*#__PURE__*/React$1.createElement(StyledTeamList, null, randomizedMembers && randomizedMembers.map(member => /*#__PURE__*/React$1.createElement(MemberItem, _extends({
    key: member.id
  }, member)))));
};

TeamList.propTypes = {
  members: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};

export default TeamList;
export { MemberItem };
